/**
 * @generated SignedSource<<0cdf2d5675add4b6a3f5e66c1c642b18>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NumberTaskUnit = "CURRENCY" | "CUSTOM";
export type RoutineIcon = "key" | "residual" | "shelf_hole" | "waste";
export type TeamIcon = "account_hard_hat" | "account_tie" | "apple" | "baby_carriage" | "baguette" | "basket" | "bed" | "bread_slice" | "broom" | "carrot" | "cart" | "cash" | "cash_register" | "cheese" | "coffe" | "cookie" | "cupcake" | "default" | "desk_lamp" | "dolly" | "fish" | "flower" | "food" | "fork_knife" | "forklift" | "fridge" | "hamburger" | "hammer_wrench" | "laptop" | "market" | "meat" | "milk" | "pineapple" | "soda" | "sofa" | "steak" | "tshirt" | "tv" | "watermelon";
import { FragmentRefs } from "relay-runtime";
export type KPIWeeklyHighlightAnalytics$data = {
  readonly icon: RoutineIcon | null;
  readonly id: string;
  readonly sectionAggregates: ReadonlyArray<{
    readonly results: ReadonlyArray<{
      readonly date: string;
      readonly value: number;
    }>;
    readonly section: {
      readonly assignedTeam: {
        readonly color: string | null;
        readonly icon: TeamIcon | null;
        readonly name: string;
      } | null;
      readonly id: string;
      readonly title: string | null;
    };
  } | null>;
  readonly team: {
    readonly color: string | null;
  };
  readonly title: string;
  readonly unit: NumberTaskUnit;
  readonly " $fragmentType": "KPIWeeklyHighlightAnalytics";
};
export type KPIWeeklyHighlightAnalytics$key = {
  readonly " $data"?: KPIWeeklyHighlightAnalytics$data;
  readonly " $fragmentSpreads": FragmentRefs<"KPIWeeklyHighlightAnalytics">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "icon",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "KPIWeeklyHighlightAnalytics",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "unit",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Team",
      "kind": "LinkedField",
      "name": "team",
      "plural": false,
      "selections": [
        (v3/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "KPISectionAggregate",
      "kind": "LinkedField",
      "name": "sectionAggregates",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineSection",
          "kind": "LinkedField",
          "name": "section",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Team",
              "kind": "LinkedField",
              "name": "assignedTeam",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "KPIAggregateResult",
          "kind": "LinkedField",
          "name": "results",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "date",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "KPI",
  "abstractKey": null
};
})();

(node as any).hash = "905730421cc8e2fb6edd26e59c013e8b";

export default node;
